module.exports = __webpack_public_path__ + "static/media/html.454a400c.png";